import * as React from 'react';
import { Space } from '../../Space/src/Space.js';
import { UI_STATE_TYPES } from '../types/UIState.types.js';
import { Head } from './Head.js';
import { Pagination } from './Pagination.js';
import { TableRows } from './TableRows.js';
import { TableView } from './TableView.js';
import { Thead } from './Thead.js';
import { UIState } from './UIState.js';

const TableContent = (props) => {
    const { table, manualPagination, isLoading, globalFilter, renderSubComponent, size } = props;
    const columnCount = table.getAllColumns().length;
    const isFiltered = !!globalFilter;
    const isFilteredEmpty = isFiltered && table.getRowCount() === 0;
    const isUnfilteredEmpty = !isFiltered && table.getRowCount() === 0;
    // eslint-disable-next-line no-nested-ternary
    const stateType = isLoading
        ? UI_STATE_TYPES.LOADING
        : // eslint-disable-next-line no-nested-ternary
            isFilteredEmpty
                ? UI_STATE_TYPES.FILTERED_EMPTY
                : isUnfilteredEmpty
                    ? UI_STATE_TYPES.EMPTY
                    : null;
    return (React.createElement(Space, { size: 24, direction: "vertical" },
        React.createElement(TableView, null,
            React.createElement(Thead, null, table.getHeaderGroups().map((headerGroup) => (React.createElement("tr", { key: `${headerGroup.id}-headergroup` }, headerGroup.headers.map((header) => (React.createElement(Head, { key: `${header.id}-header`, header: header, size: size }))))))),
            React.createElement("tbody", null, stateType ? (React.createElement("tr", null,
                React.createElement("td", { colSpan: columnCount },
                    React.createElement(UIState, { type: stateType })))) : (React.createElement(TableRows, { rows: table.getRowModel().rows, renderSubComponent: renderSubComponent, size: size })))),
        React.createElement(Pagination, { table: table, manualPagination: manualPagination })));
};

export { TableContent };
//# sourceMappingURL=TableContent.js.map
